import { useNotification } from "../contexts/NotificationContext";
import { useEffect } from "react";
import { Bell } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetAllNotifications, useGetCountUnreadNotifications } from "../hooks/notificationHooks";

const NotificationBell = () => {
    const { initialize, isInitialized } = useNotification();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const params = {
        isPaginated: true,
        page: 0,
        size: 10,
    }

    const { data: unreadCountData, refetch: refetchUnreadCount } = useGetCountUnreadNotifications()
    const unreadCount = unreadCountData?.data?.data?.count;

    const { data: notifications } = useGetAllNotifications(params);
    const notificationsData = notifications?.data?.data?.content;

    useEffect(() => {
        if (!isInitialized) {
            initialize();
        }
    }, [initialize, isInitialized]);

    useEffect(() => {
        if (notificationsData) {
            refetchUnreadCount();
        }
    }, [notificationsData, refetchUnreadCount]);

    const triggerComponent = (
        <div className="relative">
            <Bell className="w-5 h-5 hover:text-muted-foreground cursor-pointer" />
            {unreadCount > 0 && (
                <div className="absolute h-4 w-4 -top-3 -right-2 p-[10px] rounded-full bg-destructive  flex items-center justify-center" >
                    <div className="text-xs text-white rounded-full h-4 w-4 flex items-center justify-center">
                        {unreadCount}
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                {triggerComponent}
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-80 max-h-[370px] overflow-y-auto">
                {notificationsData && notificationsData.length > 0 ? (
                    <>
                        {notificationsData.map((notification: any, index: number) => (
                            <DropdownMenuItem
                                key={notification.id}
                                className={`ltr:text-left rtl:text-right w-full flex flex-col items-start py-3 cursor-pointer 
                                ${index !== notificationsData.length - 1 && "border-b border-border"}
                                ${!notification.isRead ? "bg-[#ffe7f09c] !hover:bg-[#ffe7f09c]" : ""}
                                `}

                                onClick={() => {
                                    if (notification.type === "ORDER" && notification.title === "new order") {
                                        navigate(`/dashboard/requests/${notification.itemId}`);
                                    }
                                    else if (notification.type === "ORDER" && notification.title === "cancel order") {
                                        navigate(`/dashboard/canceled/${notification.itemId}`);
                                    }
                                }}
                            >
                                <div className="font-medium capitalize w-full">{notification.title}</div>
                                <div className="text-sm text-gray-500 w-full">
                                    {notification.content}
                                </div>
                                <div className="text-xs text-muted-foreground mt-1 w-full">
                                    {(notification.createdAt)}
                                </div>
                            </DropdownMenuItem>
                        ))}
                        <DropdownMenuSeparator />
                        <DropdownMenuItem>
                            <div className="text-sm text-primary cursor-pointer" onClick={() => {
                                navigate("/dashboard/notifications");
                            }}>
                                {t("view_all_notifications")}
                            </div>
                        </DropdownMenuItem>
                    </>
                ) : (
                    <DropdownMenuItem>
                        {t("no_new_notifications")}
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default NotificationBell;
